export function numberWithDelimiter(num) {
 return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}

export function toBoolean(value) {
  return !(value === 'false' || Number(value) === 0);
}
